/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme, ButtonProps, Interpolation } from '@mui/material';


declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    primary: true;
    secondary: true;
    tertiary: true;
    quaternary: true;
  }
}

export const buttonVariants: {
	props: Partial<ButtonProps<'button', SxProps>>;
	style: Interpolation<{ theme: Theme }>;
}[] = [
	{
		props: { variant: 'inline' },
		style: {
			display: 'inline',
			padding: '0',
			fontSize: '16px',
			boxShadow: 'none',
			minWidth: 'unset',
			color: 'primary.main',
			textDecoration: 'underline',
			textDecorationSkipInk: 'auto',
			textDecorationThickness: '1px',
			textUnderlineOffset: '.15em',
			fontWeight: 500,
			'&:hover': {
				color: 'primary.dark',
				textDecoration: 'underline',
				textDecorationThickness: '1px',
				background: 'none',
			},
		},
	},
	{
		props: { variant: 'containedSuccess' },
		style: {
		  background: `green`,
		  color: "#fff",
		},
	  },
	  {
		props: { variant: 'primaryConversion' },
		style: {
		  background: '#53aa28',  			// Green 
		  color: '#000',  					// Black		  button.secondary will not work here. 
		  fontFamily:'mikado-medium',
		  fontWeight:400,
		  fontSize: 16,
		  '@media (max-width:600px)': {
           	 	fontSize: 16, 
         	},
		  '&:hover': {
				background: '#53aa28',
				color: '#000',
			},
		}
	  },
	  {
		props: { variant: 'secondaryConversion' },
		style: {
		  background: '#ff5c1d',  	//Orange
		  color: '#000',			//Black	 
		  fontFamily:'mikado-medium',
		  fontWeight:400,
		  fontSize: 16,
		  '@media (max-width:600px)': {
           	 	fontSize: 16, 
         	},
			'&:hover': {
				background: '#ff5c1d',
				color: '#000',
			},
		}
	  },
	  {
		props: { variant: 'semiConversion' },
		style: {
		  background: '#fff',		//White
		  color: '#000',			//Black
		  fontFamily:'mikado-medium',
		  fontWeight:400,
		  fontSize: 16,
		  border: '2px solid #000',
		  borderWidth: '2px !important',
			'&:hover': {
				background: '#fff',
				color: '#000',
				borderColor: '#000',
				borderWidth: '2px',
			},
		  '@media (max-width:600px)': {
           	 	fontSize: 16, 
         	},
		}
	  },
	  {
		props: { variant: 'clickThrough' },
		style: {
		  background: '#000',		//Black
		  color: '#fff',			//White
		  fontFamily:'mikado-medium',
		  fontWeight:400,
		  fontSize: 16,
		  '@media (max-width:600px)': {
           	 	fontSize: 16, 
         	},
			'&:hover': {
				background: '#000',
				color: '#fff',
			},
			'&:disabled': {
				background: '#fff',
				color: 'grey',
			},
		}
	  },
	  {
		props: { variant: 'textButton' },
		style: {
		  padding:1,
		  color: '#000',
		  fontFamily:'mikado-medium',
 		  fontWeight:400,
		  fontSize: 16,
		  '@media (max-width:600px)': {
           	 	fontSize: 16, 
         	},
			'&:hover': {
				background: 'transparent',
			},
			'&:disabled': {
				background: 'transparent',
				color: 'grey',
			},
		}
	  }
];

declare module "@mui/material/Button" {
	interface ButtonPropsVariantOverrides {
		containedSuccess:true,
		primaryConversion:true,
		secondaryConversion:true,
		semiConversion:true,
		clickThrough:true,
		textButton:true,
	}
  }